const EMPTY_ARRAY = [];

export const selectModals = state => state.modalReducer.modals || EMPTY_ARRAY;